/**
 * EmptyTile - Empty floor tile (walkable)
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class EmptyTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `empty-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.EMPTY;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/grass.png" };
  }

  clone(): EmptyTile {
    const copy = new EmptyTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "empty", id: this.id, col: this.col, row: this.row };
  }
}
